<template>
  <ErrorPageLayout
    code="403"
    title="You don't have access to this page"
    :description="description"
    hint="If you believe this is a mistake, ask your administrator to update your role or permissions."
    tone="amber"
  >
    <template #art>
      <svg viewBox="0 0 200 140" width="180" height="126" fill="none" aria-hidden="true">
        <!-- halo -->
        <ellipse cx="100" cy="74" rx="62" ry="58" fill="url(#p403-halo)" opacity="0.55"/>
        <!-- shield body -->
        <path d="M100 18 L150 36 L150 80 C150 102 130 118 100 128 C70 118 50 102 50 80 L50 36 Z"
              fill="url(#p403-shield)" stroke="#b45309" stroke-width="3" stroke-linejoin="round"/>
        <!-- lock body -->
        <rect x="78" y="68" width="44" height="34" rx="6" fill="#ffffff" stroke="#b45309" stroke-width="3"/>
        <!-- lock shackle -->
        <path d="M84 68 L84 58 C84 49 91 42 100 42 C109 42 116 49 116 58 L116 68"
              fill="none" stroke="#b45309" stroke-width="3.5" stroke-linecap="round"/>
        <!-- keyhole -->
        <circle cx="100" cy="82" r="4.5" fill="#b45309"/>
        <rect x="98" y="84" width="4" height="9" fill="#b45309"/>
        <!-- spark dots -->
        <circle cx="40" cy="40" r="3" fill="#f59e0b" opacity="0.7">
          <animate attributeName="r" values="3;5;3" dur="2.5s" repeatCount="indefinite"/>
        </circle>
        <circle cx="170" cy="50" r="3" fill="#f59e0b" opacity="0.8">
          <animate attributeName="r" values="3;5;3" dur="3.2s" repeatCount="indefinite"/>
        </circle>
        <circle cx="160" cy="120" r="2.5" fill="#b45309" opacity="0.6">
          <animate attributeName="r" values="2.5;4;2.5" dur="2.8s" repeatCount="indefinite"/>
        </circle>
        <defs>
          <radialGradient id="p403-halo">
            <stop offset="0%" stop-color="#f59e0b" stop-opacity="0.45"/>
            <stop offset="100%" stop-color="#f59e0b" stop-opacity="0"/>
          </radialGradient>
          <linearGradient id="p403-shield" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stop-color="#fef3c7"/>
            <stop offset="100%" stop-color="#fde68a"/>
          </linearGradient>
        </defs>
      </svg>
    </template>
  </ErrorPageLayout>
</template>

<script>
import ErrorPageLayout from './ErrorPageLayout.vue'

export default {
  name: 'Page403',
  components: { ErrorPageLayout },
  computed: {
    description() {
      // If the previous route is captured via query (?from=…) we can
      // tell the user which page bounced them here — clearer than a
      // generic "permission denied" line.
      const from = this.$route && this.$route.query && this.$route.query.from
      if (from) {
        return `Your current role doesn't allow access to ${from}. The system blocked the request before any data was returned.`
      }
      return "Your current role doesn't include this area. The system blocked the request before any data was returned."
    },
  },
}
</script>
